import type { TFunction } from 'i18next';

export const PROJECT_ACCEPTED_FORMATS: Record<string, string[]> = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
  'video/mp4': ['.mp4'],
  'video/quicktime': ['.mov'],
  'video/webm': ['.webm'],
  'video/3gpp': ['.3gp'],
  'video/ogg': ['.ogg'],
  'video/mpeg': ['.mpeg'],
  'application/pdf': ['.pdf'],
  'text/markdown': ['.md'],
  'text/x-markdown': ['.md'],
  'text/plain': ['.txt'],
};

// A factory, not a module-scope array: `Dropzone` iterates the array, so resolving the
// labels at import time would freeze them to whatever language was active then.
/* eslint-disable i18next/no-literal-string -- PDF/TXT/Markdown are format names, identical in every locale */
export const buildProjectUploadShowcasedFormats = (t: TFunction<'projects'>) => [
  'PDF',
  t('createProject.uploadDocumentsStep.formatImages'),
  t('createProject.uploadDocumentsStep.formatVideos'),
  'TXT',
  'Markdown',
];
/* eslint-enable i18next/no-literal-string */

export const PROJECT_FILE_SIZE_LIMIT = 100 * 1024 * 1024; // 100MB
